/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Entrar from "layouts/login";
import InformeMotores from "modules/motores/informemotores";
import ConteoInventarioSucursal from "modules/motores/conteoinventariosucursal";
import InformeMatriculasCobradas from "modules/motores/informematriculascobradas";
import Cobrosincautosfechas from "modules/motores/cobrosincautosfechas";
import Traspaso from "modules/motores/informetraspaso"
import InformeMotoresFacturados from "modules/facturacion/informemotoresfacturados";
import InformeMotoresFacturadosNuevo from "modules/facturacion/informemotoresfacturados-nuevo";
import ListadoChasisIncautados from "modules/facturacion/listadochasisincautados";
import SolicitudesCredito from "modules/facturacion/solicitudescredito";
import CuadreCaja from "modules/facturacion/cuadrecaja";
import Informepagos from "modules/pagos/informepagos";
import Auditoriarecibos from "modules/pagos/auditoriarecibos";
import Informepagoscancelados from "modules/pagos/informepagoscancelados";
import Interescobradoperiodo from "modules/pagos/interescobradoperiodo";
import Proyectadocobros from "modules/pagos/proyectadocobros";
import Pagosantcuota from "modules/pagos/pagosantcuota";
import InformePrestamo from "modules/prestamos/informeprestamos";
import ListarCanceladoFecha from "modules/prestamos/listarcanceladosporfechas";
import CancelacionPrestamos from "modules/prestamos/cancelacionprestamos";
import ReporteMorosidad from "modules/prestamos/reportemorosidad";
import ReporteAntiguedadSaldo from "modules/prestamos/antiguedaddesaldo";
import ReporteDescuentos from "modules/prestamos/informedescuentos";
import CalculadoraPrestamos from "modules/prestamos/calculadoraprestamos";
import Transferenciaschasis from "modules/motores/transferenciachasis";
import Transferenciadocumentos from "modules/motores/transferenciadocumentos";
import HistorialChasis from "modules/motores/historialchasis";
import ImportacionDatos from "modules/importacion/importacionDatos";
import ImportarXmayor from "modules/ventasxmayor/importarxmayor";
import RegistroClientes from "modules/clientessuplidores/RegistroClientes";
import DataOrbit from "modules/dataorbit";
import Informegastos from "modules/gastos/informegastos";
import Agregargasto from "modules/gastos/agregargasto";
import InformeConsignaciones from "modules/motores/Consignaciones/informeconsignaciones";

// @mui icons
import Icon from "@mui/material/Icon";
import DashboardPantalla from "layouts/dashboard/pantallacompleta";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Facturacion",
    key: "facturacion",
    programa: "facturacion",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/facturacion",
    component: '',
    collapse: [
      {
        type: "collapse",
        name: "Motores Facturados",
        key: "informemotoresfacturados",
        route: "/facturacion/informemotoresfacturados",
        component: <InformeMotoresFacturados />,
      },
      {
        type: "collapse",
        name: "Motores Facturados (Nuevo)",
        key: "informemotoresfacturados",
        route: "/facturacion/informemotoresfacturados-nuevo",
        component: <InformeMotoresFacturadosNuevo />,
      },

      {
        type: "collapse",
        name: "Chasis Incautados",
        key: "listadochasisincautados",
        route: "/facturacion/listadochasisincautados",
        component: <ListadoChasisIncautados />,
      },
      {
        type: "collapse",
        name: "Solicitudes de Crédito",
        key: "solicitudescredito",
        route: "/facturacion/solicitudescredito",
        component: <SolicitudesCredito />,
      },
      {
        type: "collapse",
        name: "Cuadre de Caja",
        key: "cuadrecaja",
        route: "/facturacion/cuadrecaja",
        component: <CuadreCaja />,
      },

    ],
  },
  {
    type: "collapse",
    name: "Motores",
    key: "motores",
    programa: "motores",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/motores",
    component: '',
    collapse: [
      {
        type: "collapse",
        name: "Informe Motores",
        key: "informemotores",
        route: "/motores/informemotores",
        component: <InformeMotores />,
      },
      {
        type: "collapse",
        name: "Conteo por Sucursal",
        key: "conteoinventariosucursal",
        route: "/motores/conteoinventariosucursal",
        component: <ConteoInventarioSucursal />,
      },

      {
        type: "collapse",
        name: "Historial Chasis",
        key: "historialchasis",
        route: "/motores/historialchasis",
        component: <HistorialChasis />,
      },
      
      {
        type: "collapse",
        name: "Transferencias Chasis",
        key: "transferenciachasis",
        route: "/motores/transferenciachasis",
        component: <Transferenciaschasis />,
      },
      {
        type: "collapse",
        name: "Cobros Incautos Fechas",
        key: "cobrosincautosfechas",
        route: "/motores/cobrosincautosfechas",
        component: <Cobrosincautosfechas />,
      },
      {
        type: "collapse",
        name: "InformeTraspaso",
        key: "traspaso",
        route: "/motores/traspaso",
        component: <Traspaso />,
      },
      {
        type: "collapse",
        name: "Inventario Documentos",
        key: "inventariomatriculas",
        route: "/motores/inventariodocumentos",
        component: <Transferenciadocumentos />,
      },
      {
        type: "collapse",
        name: "Consignaciones",
        key: "consignaciones",
        route: "/motores/consignaciones",
        component: <InformeConsignaciones />,
      },

    ],
  },
  {
    type: "collapse",
    name: "Pagos",
    key: "pagos",
    programa: "pagos",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/pagos/auditoriarecibos",
    component: '' ,
    collapse: [
      {
        type: "collapse",
        name: "Informe de Pagos",
        key: "informepagos",
        route: "/pagos/informepagos",
        component: <Informepagos />,
      },
      {
        type: "collapse",
        name: "Auditoria Recibos",
        key: "auditoriarecibos",
        route: "/pagos/auditoriarecibos",
        component: <Auditoriarecibos />,
      },
      {
        type: "collapse",
        name: "Informe Pagos Cancelados",
        key: "informepagoscancelados",
        route: "/pagos/informepagoscancelados",
        component: <Informepagoscancelados />,
      },
      {
        type: "collapse",
        name: "Interes Cobrado Periodo",
        key: "intresescobradosperiodos",
        route: "/pagos/interescobradosperiodos",
        component: <Interescobradoperiodo />,
      },
      {
        type: "collapse",
        name: "Proyectado Cobros",
        key: "proyectadocobros",
        route: "/pagos/proyectadocobros",
        component: <Proyectadocobros />,
      },
      {
        type: "collapse",
        name: "Pagos Anteriores 1ra Cuota",
        key: "pagosanteriores1rcuota",
        route: "/pagos/pagosanteriores1rcuota",
        component: <Pagosantcuota />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Gastos",
    key: "gastos",
    programa: "gastos",
    icon: <Icon fontSize="small">money_off</Icon>,
    route: "/gastos/informegastos",
    component: '',
    collapse: [
      {
        type: "collapse",
        name: "Informe Gastos",
        key: "informegastos",
        route: "/gastos/informegastos",
        component: <Informegastos />,
      },
      {
        type: "collapse",
        name: "Agregar Gasto",
        key: "agregargasto",
        route: "/gastos/agregar",
        component: <Agregargasto />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Prestamos",
    key: "prestamos",
    programa: "prestamos",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/prestamos/informeprestamos",
    component: '',
    collapse: [
      {
        type: "collapse",
        name: "Informe Prestamos",
        key: "informeprestamos",
        route: "/prestamos/informeprestamos",
        component: <InformePrestamo />,
      },
      {
        type: "collapse",
        name: "Cancelados por Fechas",
        key: "listarcanceladosporfechas",
        route: "/prestamos/listarcanceladosporfechas",
        component: <ListarCanceladoFecha />,
      },
      {
        type: "collapse",
        name: "Cancelar préstamo",
        key: "cancelacionprestamos",
        route: "/prestamos/cancelacionprestamos",
        component: <CancelacionPrestamos />,
      },
      {
        type: "collapse",
        name: "Reporte de Morosidad",
        key: "reportemorosidad",
        route: "/prestamos/reportemorosidad",
        component: <ReporteMorosidad />,
      },
      {
        type: "collapse",
        name: "Antigüedad de Saldo",
        key: "antiguedaddesaldo",
        route: "/prestamos/antiguedaddesaldo",
        component: <ReporteAntiguedadSaldo />,
      },

      {
        type: "collapse",
        name: "Reporte de Descuentos a Prestamos",
        key: "descuentosprestamos",
        route: "/prestamos/descuentosprestamos",
        component: <ReporteDescuentos />,
      },
      
      {
        type: "collapse",
        name: "Calculadora de Préstamos",
        key: "calculadoraprestamos",
        route: "/prestamos/calculadoraprestamos",
        component: <CalculadoraPrestamos />,
      },

      {
        type: "collapse",
        name: "Importacion de Datos",
        key: "importaciondatos",
        route: "/importacion/importaciondatos",
        component: <ImportacionDatos/>,
      },

      {
        type: "collapse",
        name: "Importar Ventas x Mayor",
        key: "importarventasxmayor",
        // Comparte permiso con "Importacion de Datos": quien puede importar
        // datos tambien ve la importacion de ventas x mayor.
        programa: "importaciondatos",
        route: "/importacion/ventasxmayor",
        component: <ImportarXmayor/>,
      },

    ],
  },
 
  {
    type: "collapse",
    name: "Clientes/Suplidores",
    key: "clientessuplidores",
    programa: "clientessuplidores",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/clientessuplidores",
    component: '',
    collapse: [
      {
        type: "collapse",
        name: "Registro Clientes/Suplidores",
        key: "registroclientessuplidores",
        route: "/clientessuplidores/registroclientessuplidores",
        component: <RegistroClientes />,
      },
    ],
  },

  {
    type: "collapse",
    name: "DataOrbit",
    key: "dataorbit",
    programa: "dataorbit",
    icon: <Icon fontSize="small">hub</Icon>,
    route: "/dataorbit",
    component: <DataOrbit />,
  },

  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/login",
    component: <Entrar />,
  },
  {
    name: "Sign Up",
    key: "sign-up",
    route: "/login",
    component: <Entrar />,
  },


];

export default routes;
